import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      background: "#FFFFFF",
      cursor: "pointer",
      border: "1px solid #C4C4C4",
    },
    imageWrapper: {
      height: 175,
      position: "relative",
    },
    image: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
    },
    accordion: {
      borderRadius: "0px 0px 10px 10px !important",
      boxShadow: "none",
    },
    accordionSummary: {
      padding: 0,
      "& .MuiAccordionSummary-content": {
        display: "block",
        margin: 0,
      },
    },
    accordionDetails: {
      backgroundColor: "#f5f5f5",
      flexDirection: "column",
      padding: 16,
      borderTop: "1px solid #C4C4C4",
    },
    breakfastInformation: {
      display: "flex",
      gap: 8,
      height: 20,
    },
    roomTypeNameWrapper: {
      backgroundColor: "#242424",
      padding: 10,
    },
    roomTypeName: {
      fontWeight: "bold",
      color: "white",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      width: "90%",
      fontSize: 16,
    },
    roomRatePlanName: {
      fontWeight: "bold",
      fontSize: 14,
      color: "#25282b",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      width: "90%",
      textDecoration: "underline",
    },
    contentWrapper: {
      padding: 12,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    headWrapper: {
      display: "flex",
      alignItems: "flex-start",
      marginLeft: -8,
    },
    capacity: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    priceWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      marginTop: 2,
    },
    price: {
      fontSize: 14,
      fontWeight: "bold",
      color: "#52575c",
    },
    button: {
      color: "#ffffff",
      width: 72,
      height: 24,
      fontSize: 10,
      textTransform: "capitalize",
      backgroundColor: "#9e007e",
      boxShadow: "none",
      borderRadius: 0,
      "&:hover": {
        backgroundColor: "#9e007e",
        boxShadow: "none",
      },
    },
    plusMinusWrapper: {
      display: "flex",
      alignItems: "center",
    },
    quantity: {
      height: 24,
      width: 24,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    imageIndex: {
      position: "absolute",
      right: 0,
      bottom: 0,
      marginRight: 12,
      marginBottom: 12,
      display: "flex",
      alignItems: "center",
      padding: "6px 12px",
      backgroundColor: "rgb(0 0 0 / 0.8)",
      borderRadius: 8,
    },
  })
);

export default useStyles;
